import { ToastProvider } from "../modules/providers/index";
import ErrorBoundary from "../utils/error-boundary";

const ToastsApp = (props) => (
  <ErrorBoundary>
    <ToastProvider initial={{ success: props.notice, danger: props.alert }} />
  </ErrorBoundary>
);

export default ToastsApp;
